"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _BarsItem = _interopRequireDefault(require("./BarsItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Bars extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getBarGroups", () => {
      const bars = this.props.bars;
      let groups = {};
      bars.map(bar => {
        const x = bar.x,
              y = bar.y,
              width = bar.width,
              data = bar.data;
        let index = data.index;

        if (!groups[index]) {
          groups[index] = {
            id: index,
            x: x,
            y: y,
            width: 0,
            bars: []
          };
        }

        groups[index].width = groups[index].width + width;
        groups[index].bars.push(bar);
      });
      return Object.values(groups);
    });

    _defineProperty(this, "getBar", (bar, index) => {
      const groupMode = this.props.groupMode;
      let width = bar.width,
          x = bar.x;

      if (groupMode === "grouped") {
        width = width + 6 * index;
        x = x - index * 12;
      } else {
        width = width - 12;
        x = x + 6;
      }

      return _extends({}, bar, {
        width: width,
        x: x
      });
    });

    _defineProperty(this, "renderBar", (bar, index) => {
      //        const barprops = this.getBar(bar, index);
      bar = _extends({}, bar, {
        id: bar.key
      });
      const current = this.props.current;
      const isCurrent = current && current.id === bar.id;
      return _react.default.createElement(_BarsItem.default, _extends({}, this.props, {
        bar: bar,
        isCurrent: isCurrent
      }));
    });

    _defineProperty(this, "renderGroup", (group, index) => {
      const id = group.id,
            x = group.x,
            y = group.y,
            bars = group.bars;
      const className = "bars  bars--" + id;
      return _react.default.createElement("g", {
        key: index,
        className: className
      }, bars.map(this.renderBar));
    });
  }

  render() {
    const groups = this.getBarGroups();
    console.log('BARS', this.props);
    return _react.default.createElement("g", {
      className: "bars"
    }, groups.map(this.renderGroup));
  }

}

var _default = Bars;
exports.default = _default;
module.exports = exports.default;